module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-00-33b31e60796db814ba70e2b5da58ccfb.svg";